import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import type { PortalTarget } from '../../../store/projectStore';
import type { TargetsCatalogSliceStatus } from '../../../hooks/useTargets';
import {
  ATTACK_SURFACES,
  isAttackSurfaceEnabled,
  type AttackSurfaceConfig,
  type SurfaceLabelKey,
} from './attackSurfaces';

export type AttackSurfaceGroup = {
  surface: AttackSurfaceConfig;
  label: string;
  targets: PortalTarget[];
};

export function useAttackSurfaceGroups({
  targets,
  catalogSliceStatus,
}: {
  targets: PortalTarget[];
  catalogSliceStatus: TargetsCatalogSliceStatus;
}): AttackSurfaceGroup[] {
  const t = useTranslations('layout');

  return useMemo(() => {
    const surfaceLabels: Record<SurfaceLabelKey, string> = {
      webApplications: t('webApplications'),
      externalNetworks: t('externalNetworks'),
      internalNetworks: t('internalNetworks'),
      aiApplications: t('aiApplications'),
    };

    return ATTACK_SURFACES.filter((surface) =>
      isAttackSurfaceEnabled({ surface, catalogSliceStatus }),
    ).map((surface) => ({
      surface,
      label: surfaceLabels[surface.labelKey],
      targets: targets.filter(
        (target) => target.targetType === surface.targetType,
      ),
    }));
  }, [catalogSliceStatus, t, targets]);
}
